// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_extra__Muskz {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.style_extra__title__VM9UN {
  font-weight: 700;
  font-size: 1.6rem;
  line-height: 20px;
  color: rgb(247, 246, 255);
  text-transform: uppercase;
}
.style_extra__subtitle__uqwK7 {
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 17px;
  color: rgba(255, 255, 255, 0.75);
  margin-bottom: 17px;
}

.style_top__SWgSI {
  border: 2px solid rgb(85, 46, 224);
  border-radius: 15px;
  padding: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.style_top__item__PAzB\\+ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: rgba(255, 255, 255, 0.75);
  font-weight: 500;
  font-size: 1.2rem;
  padding: 0 4px;
}
.style_top__item__part__ITYiy {
  display: flex;
  color: rgba(255, 255, 255, 0.75);
  font-weight: 500;
  font-size: 1.2rem;
  gap: 6px;
  align-items: center;
}
.style_top__item__part__ITYiy img {
  width: 14px;
  height: 14px;
}
.style_top__item__title__fG8W- {
  font-weight: 600;
  color: rgb(255, 255, 255);
  font-size: 1.6rem;
  line-height: 16px;
  min-width: 45px;
}`, "",{"version":3,"sources":["webpack://./src/features/clans-war/components/clan-wars-rewards/extra-rewards/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AADF;AAEE;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;AAAJ;AAEE;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gCAAA;EACA,mBAAA;AAAJ;;AAIA;EACE,kCAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AADF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAAJ;AACI;EACE,aAAA;EACA,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,QAAA;EACA,mBAAA;AACN;AAAM;EACE,WAAA;EACA,YAAA;AAER;AACI;EACE,gBAAA;EACA,yBChDE;EDiDF,iBAAA;EACA,iBAAA;EACA,eAAA;AACN","sourcesContent":["@import 'public/assets/colors';\n\n.extra {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  &__title {\n    font-weight: 700;\n    font-size: 1.6rem;\n    line-height: 20px;\n    color: rgba(247, 246, 255, 1);\n    text-transform: uppercase;\n  }\n  &__subtitle {\n    font-weight: 500;\n    font-size: 1.4rem;\n    line-height: 17px;\n    color: rgba(255, 255, 255, 0.75);\n    margin-bottom: 17px;\n  }\n}\n\n.top {\n  border: 2px solid rgba(85, 46, 224, 1);\n  border-radius: 15px;\n  padding: 8px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  &__item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: rgba(255, 255, 255, 0.75);\n    font-weight: 500;\n    font-size: 1.2rem;\n    padding: 0 4px;\n    &__part {\n      display: flex;\n      color: rgba(255, 255, 255, 0.75);\n      font-weight: 500;\n      font-size: 1.2rem;\n      gap: 6px;\n      align-items: center;\n      img {\n        width: 14px;\n        height: 14px;\n      }\n    }\n    &__title {\n      font-weight: 600;\n      color: $white;\n      font-size: 1.6rem;\n      line-height: 16px;\n      min-width: 45px;\n    }\n  }\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"extra": `style_extra__Muskz`,
	"extra__title": `style_extra__title__VM9UN`,
	"extra__subtitle": `style_extra__subtitle__uqwK7`,
	"top": `style_top__SWgSI`,
	"top__item": `style_top__item__PAzB+`,
	"top__item__part": `style_top__item__part__ITYiy`,
	"top__item__title": `style_top__item__title__fG8W-`
};
export default ___CSS_LOADER_EXPORT___;
